<greco-station-details [station]="station"> </greco-station-details>
